module.exports = __webpack_public_path__ + "media/images/social/social-icon-google-766fa6c046d8702a9b57724b7ef44a08.svg";